import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_PRODUCT_UNIT_BY_PRODUCT_ID_REQUEST,
  GET_PRODUCT_UNIT_TYPE_REQUEST,
  ADD_PRODUCT_UNIT_REQUEST,
  UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
  UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_REQUEST,
  DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
} from "./actionTypes";
import {
  updateProductUnitStatusByProductUnitIdResponse,
  getProductUnitTypeResponse,
  getProductUnitByProductIdResponse,
  addProductUnitResponse,
  updateProductUnitByProductUnitIdResponse,
  deleteProductUnitByProductUnitIdResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getProductUnitByProductId({ payload: { productId } }) {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/ProductUnit/GetAllByProductDetailId/" + productId,
      ""
    );
    yield put(getProductUnitByProductIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* addProductUnit({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "post", "/ProductUnit", data);
    yield put(addProductUnitResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductUnitByProductUnitId({
  payload: { productUnitId, data },
}) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/ProductUnit/" + productUnitId,
      data
    );
    yield put(updateProductUnitByProductUnitIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteProductUnitByProductUnitId({ payload: { productUnitId } }) {
  try {
    const response = yield call(
      invokeApi,
      "delete",
      "/ProductUnit/" + productUnitId
    );
    yield put(deleteProductUnitByProductUnitIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateProductUnitStatusByProductUnitId({
  payload: { productUnitId, status },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/ProductUnit/" + productUnitId + "/" + status
    );
    yield put(updateProductUnitStatusByProductUnitIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* getProductUnitType() {
  try {
    const response = yield call(
      invokeApi,
      "get",
      "/ProductUnit/GetProductUnitTypes",
      ""
    );
    yield put(getProductUnitTypeResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchProductUnitMaster() {
  yield takeEvery(
    GET_PRODUCT_UNIT_BY_PRODUCT_ID_REQUEST,
    getProductUnitByProductId
  );
  yield takeEvery(GET_PRODUCT_UNIT_TYPE_REQUEST, getProductUnitType);
  yield takeEvery(ADD_PRODUCT_UNIT_REQUEST, addProductUnit);
  yield takeEvery(
    UPDATE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
    updateProductUnitByProductUnitId
  );
  yield takeEvery(
    DELETE_PRODUCT_UNIT_BY_PRODUCT_UNIT_ID_REQUEST,
    deleteProductUnitByProductUnitId
  );
  yield takeEvery(
    UPDATE_PRODUCT_UNIT_STATUS_BY_PRODUCT_UNIT_ID_REQUEST,
    updateProductUnitStatusByProductUnitId
  );
}

function* productUnitSaga() {
  yield all([fork(watchProductUnitMaster)]);
}

export default productUnitSaga;
